// import { Grid, Toolbar } from "@material-ui/core";
// import ContractTableView, { ContractItemType } from "../common/TableView";
// import SearchForm from "../common/SearchForm";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ButtonArea from "../common/ButtonArea";
import { useNavigate } from "react-router-dom";
import { ApplicationProtectedRouting } from "../../Routing";

const WebList = () => {
    const navigate = useNavigate();
    const PAGE_NAME = "Web利用状況";

    const SearchFormList = () => {
        return (
            <Box sx={{p:3}}>
                {/* <Grid container spacing={2} alignItems="center">
                    <Grid item xs={2}>
                        <SearchForm id="contractId" name="contractId" label="契約ID" />
                    </Grid>
                    <Grid item xs={2}>
                        <SearchForm id="organizationName" name="organizationName" label="組織名" />
                    </Grid>
                    <Grid item xs={2}>
                        <SearchForm id="status" name="status" label="ステータス" />
                    </Grid>
                    <Grid item xs={2}>
                        <SearchForm id="term" name="term" label="契約開始日時" />
                    </Grid>
                    <Grid item xs={2}>
                        <SearchForm id="term" name="term" label="契約終了日時" />
                    </Grid>
                    <Grid item xs>
                        <Button variant="contained" onClick={searchButtonClick}>検索</Button>
                    </Grid>
                </Grid> */}
            </Box>
        )
    }

    const buttonClick = (buttonName: string) => {
        console.log(`${buttonName}がクリックされました`);
    }

    const createButtonClick = () => {
        buttonClick("インポート");
        navigate(ApplicationProtectedRouting.contractCreate.path());
    }

    const exportButtonClick = () => {
        buttonClick("エクスポート");
    }

    const searchButtonClick = () => {
        buttonClick("検索");
    }

    // const listHeader: ContractItemType = 
    //     {id: "契約ID", name: "組織名", status: "ステータス", startDate: "契約開始日時", expireDate: "契約終了日時"};
    
    return (
        <Box component="main" sx={{ flexGrow: 1, p: 3}}>
            <ButtonArea pageName={PAGE_NAME}>
                <Button variant="contained" onClick={createButtonClick}>新規追加</Button>
                <Button variant="contained" onClick={exportButtonClick}>エクスポート</Button>
            </ButtonArea>
            <Box sx={{pt:10}}>
                <SearchFormList />
                {/* <ContractTableView listNum={5} headerItem={listHeader} items={items} detailLink={ApplicationRouting.contractDetail.path}/> */}
            </Box>
        </Box>
    )
};

export default WebList;